function MyAccountHeadingDirective() {
	return {
		restrict: 'E',
		template: require('./standard-heading-template.html'),
		require: '^wowReviewOverview',
		scope: {
			title: '@',
			zeroResultsMessage: '@'
		},
		link(scope, element, attr, ctrl) {
			scope.hasReviews = () => {
				return ctrl.reviews.length > 0;
			};
		}
	};
}

module.exports = MyAccountHeadingDirective;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/headings/standard-heading-directive.js
 **/